import styled from "styled-components";

import Heading from "../../ui/Heading";
import Row from "../../ui/Row";

import Spinner from "../../ui/Spinner";
import TodayItem from "./TodayItem";
import { useCabins } from "../cabins/useCabins";

const StyledToday = styled.div`
  /* Box */
  background-color: var(--color-grey-0);
  border: 1px solid var(--color-grey-100);
  border-radius: var(--border-radius-md);

  padding: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  grid-column: 1 / span 2;
  padding-top: 2.4rem;

  @media (max-width: 832px) {
    width: 100%;
  }
`;

const TodayList = styled.ul`
  overflow: scroll;
  overflow-x: scroll;

  /* Removing scrollbars for webkit, firefox, and ms, respectively */
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const NoActivity = styled.p`
  text-align: center;
  font-size: 1.8rem;
  font-weight: 500;
  margin-top: 0.8rem;
`;

function TodayActivity() {
  const { isLoading, cabins } = useCabins()

  return (
    <StyledToday>
      <Row type="horizontal">
        <Heading as="h2">Hoje</Heading>
      </Row>

      {!isLoading ? (
        cabins?.length > 0 ? (
          <TodayList>
            {cabins.map((athlete) => (
              <TodayItem athlete={athlete} key={athlete.id} />
            ))}
          </TodayList>
        ) : (
          <NoActivity>Sem atividades hoje...</NoActivity>
        )
      ) : (
        <Spinner />
      )}
    </StyledToday>
  );
}

export default TodayActivity;
